import { makeStyles } from "@mui/styles";
import * as React from "react";

const useStyles = makeStyles(theme => ({
	container: {
		display: "flex",
		alignItems: "center",
		margin: "20px 0"
	},
	border: {
		borderBottom: "2px solid lightgray",
		width: "100%"
	},
	content: {
		paddingTop: 4,
		paddingBottom: 4,
		paddingRight: 16,
		paddingLeft: 16,
		fontWeight: 500,
		fontSize: 18,
		color: "lightgray"
	}
}));

export const DividerWithText = ({ children }) => {
	const classes = useStyles();
	return (
		<div className={classes.container}>
			<div className={classes.border} />
				<span className={classes.content}>
					{children}
				</span>
			<div className={classes.border} />
		</div>
	);
}
